import { RaisinContainer as Container, Typography } from '@raisin/components-lib';
import { getLocale, STARS, TRUSTPILOT_PROFILE_URL } from '@raisin/cp-utils';
import { useT } from '@transifex/react';
import React from 'react';
import { injectIntl } from 'react-intl';
import messages from './messages';
import * as S from './styles';
import { mapScoreValueToScoreText, TrustPilotIcon } from './utils';
const TrustpilotBar = ({ intl, trustpilotData }) => {
    var _a;
    let stars = 0;
    if (trustpilotData === null || trustpilotData === void 0 ? void 0 : trustpilotData.score_value) {
        stars = Math.round(trustpilotData.score_value * 2) / 2;
    }
    const Image = STARS[stars];
    const { region } = getLocale(intl.locale);
    const t = useT();
    return (React.createElement(S.Background, null,
        React.createElement(Container, { maxWidth: "xl" },
            React.createElement(S.Wrapper, null,
                React.createElement(S.InnerWrapper, null,
                    React.createElement(Typography, { variant: "body1" }, t(messages.title)),
                    React.createElement(S.StarsWrapper, null,
                        React.createElement(S.StarsLink, { href: TRUSTPILOT_PROFILE_URL[region], target: "_blank", rel: "noreferrer" },
                            React.createElement(S.Stars, null,
                                React.createElement(Image, null)),
                            React.createElement(S.StarsText, { "data-testid": "trustpilot-stars" }, t(messages.starsText, {
                                scoreText: mapScoreValueToScoreText(trustpilotData === null || trustpilotData === void 0 ? void 0 : trustpilotData.score_value),
                            })))),
                    React.createElement(S.ReviewsText, null, t(messages.reviewsCount, {
                        countOfReviews: ((_a = trustpilotData === null || trustpilotData === void 0 ? void 0 : trustpilotData.count_of_reviews) !== null && _a !== void 0 ? _a : 0).toLocaleString(region),
                    }))),
                React.createElement(S.LogoLink, { href: TRUSTPILOT_PROFILE_URL[region], target: "_blank", rel: "noreferrer" },
                    React.createElement(TrustPilotIcon, null))))));
};
export default injectIntl(TrustpilotBar);
//# sourceMappingURL=index.js.map